declare var $: any;

export default function headerSearchToggle() {
(function() {
    $('.js-header-search-trigger, .js-header-search-close').on('click', function(){
        $('.js-header-search-trigger').toggleClass('is-active');
        $('.js-header-search-close').toggleClass('is-active');
        $('.js-header-nav-list').toggleClass('is-active');
        $('.js-header-search-body').toggleClass('is-active');
        $('.p_header__footer').toggleClass('is-active');
        $('.p-header__container--nav').toggleClass('is-hide');
    });
}());
}
